module.exports = __webpack_public_path__ + "static/media/aloki_upadhyay.102e269f.png";